import React from "react";
import { Link } from "gatsby";

const Cta = () => {
  return (
    <div className="relative w-full bg-brand-bg">
      <div className="relative w-full">
        <section className="py-20">
          <div className="flex flex-col md:flex-row items-center justify-between max-w-5xl mx-auto">
            <div className="max-w-lg text-center md:text-left mb-8 md:mb-0">
              <p className="subtitle">Let's Discuss Your Project</p>
              <h2 className="text-slate-100">Ready to get Started?</h2>
              <p className="mt-5 text-slate-200">
                Are you ready to take the next step towards enhancing your
                online presence? I'm excited to hear from you and help turn your
                vision into reality.
              </p>
            </div>
            <div>
              <Link to="/contact" className="mt-5 relative button">
                Let's Work Together
              </Link>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Cta;
